import { useMutation } from '@gogame/query';

import { createAffiliate } from 'scenes/Affiliates/sources/affiliates';

import { create } from '../queryKeyFactory';

export const useCreateAffiliate = () => {
  const createMutation = useMutation(create(), createAffiliate, {
    successMessage: () => `Affiliate created`,
    errorMessage: (e) => e.message,
  });
  return [createMutation.mutateAsync, createMutation];
};
